import React from "react";
import envelope from "../Images/invitationgif2.mp4";
import "../styles/Envelope.css";

function Envelope() {
  return (
    <video
      src={envelope}
      autoPlay
      loop
      muted
      playsInline
      className="responsive-video"
    />
  );
}

export default Envelope;
